export const demandsQueryKeys = {
  all: () => ['/demands'] as const,
  lists: () => [...demandsQueryKeys.all(), 'list'] as const,
  list: (params: Record<string, unknown>) =>
    [...demandsQueryKeys.lists(), JSON.stringify(params)] as const,
  detail: (id: number) => ['/demands', id] as const,
  comments: (id: number) => ['/demands', id, 'comments'] as const,
  attachments: (id: number) => ['/demands', id, 'attachments'] as const,
  reviewers: (id: number) => ['/demands', id, 'reviewers'] as const,
  matrix: () => ['getMatrixDemands'] as const,
};
